module.exports = __webpack_public_path__ + "img/symbol_3.3ba5880a.png";